export default "__VITE_ASSET__p5tkZrct__"